import { render, staticRenderFns } from "./SubsidiariesDetailComponent.vue?vue&type=template&id=4278e6be"
import script from "./SubsidiariesDetailComponent.vue?vue&type=script&lang=js"
export * from "./SubsidiariesDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports